const GenderInput = ({ gender, onChange, className }) => {
  return (
    <div className="form-control">
      {!gender && (
        <span className="text-sm text-left mt-1">성별을 선택하세요.</span>
      )}
      <div
        className={`join w-1/2 text-primary-content border-opacity-20 border-base-content ${
          className || ""
        }`}
      >
        <input
          id="gender_m"
          className={`join-item btn bg-transparent flex-auto border-inherit text-inherit font-normal hover:border-opacity-0 hover:bg-primary-focus checked:bg-primary checked:font-bold`}
          type="radio"
          name="options"
          aria-label="남성"
          checked={gender ? gender === "M" : false}
          onChange={onChange}
        />
        <input
          id="gender_f"
          className={`join-item btn bg-transparent flex-auto border-inherit text-inherit font-normal hover:border-opacity-0 hover:bg-primary-focus checked:bg-primary checked:font-bold`}
          type="radio"
          name="options"
          aria-label="여성"
          checked={gender ? gender === "F" : false}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default GenderInput;
